module.exports = __webpack_public_path__ + "media/images/missing-search-image-e980ac32.png";